import React from 'react';
import { useStyletron } from 'baseui';
import { RELATIONSHIP_CONSTANTS } from '../constants';
import type { RelationshipT } from '../types/relationship';
import { formatFrameRange } from '../utils';
import { CreateRelationshipButton } from './create-relationship-button';
import { RelationshipActionButtons } from './relationship-action-button';
type RelationshipsPanelViewerPropsT = {
  relationships: RelationshipT[];
  getTargetDisplayName: (annotationId: string) => string;
  onCreateRelationship?: () => void;
  onEditRelationship?: (relationshipId: string) => void;
  onDeleteRelationship?: (relationshipId: string) => void;
  isVideoTask?: boolean;
  readOnly?: boolean;
};
export const RelationshipsPanelViewer = ({
  relationships,
  getTargetDisplayName,
  onCreateRelationship,
  onEditRelationship,
  onDeleteRelationship,
  isVideoTask,
  readOnly
}: RelationshipsPanelViewerPropsT) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.sizing.scale600,
    paddingBottom: theme.sizing.scale600
  })}>
      {relationships.map(relationship => <div key={relationship.id} className={css({
      alignItems: 'center',
      backgroundColor: theme.colors.backgroundPrimary,
      border: `${theme.sizing.scale0} solid ${theme.colors.borderOpaque}`,
      borderRadius: theme.borders.radius300,
      display: 'flex',
      gap: theme.sizing.scale500,
      justifyContent: 'space-between',
      padding: theme.sizing.scale500
    })}>
          <div className={css({
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: theme.sizing.scale200,
        minWidth: 0
      })}>
            <div className={css({
          ...theme.typography.LabelSmall,
          margin: 0
        })}>
              {relationship.relationshipLabel.relationshipLabelName}
            </div>
            <div className={css({
          ...theme.typography.LabelXSmall,
          color: theme.colors.contentTertiary,
          margin: 0
        })}>
              {RELATIONSHIP_CONSTANTS.TARGET_PREFIX} -{' '}
              {getTargetDisplayName(relationship.targetAnnotationId)}
            </div>
            {isVideoTask && relationship.frameRanges.length > 0 && <div className={css({
          ...theme.typography.LabelXSmall,
          color: theme.colors.contentTertiary,
          margin: 0
        })}>
                {RELATIONSHIP_CONSTANTS.FRAMES}{' '}
                {relationship.frameRanges.map(frameRange => formatFrameRange(frameRange)).join(', ')}
              </div>}
          </div>

          {!readOnly && onEditRelationship && onDeleteRelationship && <RelationshipActionButtons relationshipId={relationship.id} onEdit={onEditRelationship} onDelete={onDeleteRelationship} />}
        </div>)}

      {!readOnly && <CreateRelationshipButton label="Create new relationship" onClick={onCreateRelationship} variant="button" />}
    </div>;
};